<template>
  <div>
    <div class="header">
      <div class="container">
        <a href="#" class="logo">
          <img src="@/../images/logopnp.svg" alt />
        </a>
        <nav class="menu">
          <ul>
            <li>
              <a
                href="https://fb.com/petsnpirates"
                target="_blank"
                @click="track('facebook', 'Header')"
                v-tooltip="'Follow us on Facebook'"
              >
                <img src="@/../images/button-fb-white.svg" alt class="button" />
              </a>
            </li>
            <li>
              <a
                href="#subscribe"
                v-scroll-to="{el: '#subscribe'}"
                @click="track('email', 'Header')"
                v-tooltip="'Subscribe'"
              >
                <img src="@/../images/button-mail-white.svg" alt class="button" />
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
    <img src="@/../images/bg-header.svg" alt class="bg-header" />
  </div>
</template>
<script>
export default {
  name: "Header",
  methods: {
    track(action, category) {
      this.$gtag.event(action, {
        eventCategory: category,
      });
      window.fbq("trackCustom", action);
    },
  }
};
</script>
<style lang="scss">
.header {
  z-index: 100;
  padding: 1rem 0 1rem 0;
  width: 100%;
  position: relative;
  background-color: $green;
  .container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
    @media screen and (min-width: $tablet) {
        flex-direction: row;
      }
  }
  .logo {
    img {
      width: auto;
      height: $logo-height-mobile;
      @media screen and (min-width: $tablet) {
        height: $logo-height-desktop;
      }
    }
  }
  nav.menu {
    ul {
      list-style: none;
      padding: 0;
      margin: 0;
      li {
        display: inline-block;
        margin: 1rem 1rem 0 1rem;
        img {
          width: 2rem;
          height: auto;
        }
      }
    }
  }
}

.bg-header {
  width: 100%;
  height: auto;
}

.tooltip {
  display: block !important;
  z-index: 10000;

  .tooltip-inner {
    background: $orange;
    color: white;
    border-radius: 16px;
    padding: 5px 10px 4px;
  }

  .tooltip-arrow {
    width: 0;
    height: 0;
    border-style: solid;
    position: absolute;
    margin: 5px;
    border-color: $orange;
    z-index: 1;
  }

  &[x-placement^="top"] {
    margin-bottom: 2rem;

    .tooltip-arrow {
      border-width: 5px 5px 0 5px;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      bottom: -5px;
      left: calc(50% - 5px);
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  &[x-placement^="bottom"] {
    margin-top: 5px;

    .tooltip-arrow {
      border-width: 0 5px 5px 5px;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-top-color: transparent !important;
      top: -5px;
      left: calc(50% - 5px);
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  &[x-placement^="right"] {
    margin-left: 5px;

    .tooltip-arrow {
      border-width: 5px 5px 5px 0;
      border-left-color: transparent !important;
      border-top-color: transparent !important;
      border-bottom-color: transparent !important;
      left: -5px;
      top: calc(50% - 5px);
      margin-left: 0;
      margin-right: 0;
    }
  }

  &[x-placement^="left"] {
    margin-right: 5px;

    .tooltip-arrow {
      border-width: 5px 0 5px 5px;
      border-top-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      right: -5px;
      top: calc(50% - 5px);
      margin-left: 0;
      margin-right: 0;
    }
  }

  &.popover {
    $color: #f9f9f9;

    .popover-inner {
      background: $color;
      color: black;
      padding: 24px;
      border-radius: 5px;
      box-shadow: 0 5px 30px rgba(black, 0.1);
    }

    .popover-arrow {
      border-color: $color;
    }
  }

  &[aria-hidden="true"] {
    visibility: hidden;
    opacity: 0;
    transition: opacity 0.15s, visibility 0.15s;
  }

  &[aria-hidden="false"] {
    visibility: visible;
    opacity: 1;
    transition: opacity 0.15s;
  }
}
</style>